module.exports = __webpack_public_path__ + "static/eastwood-done-ce79ee02e5b58d918af1fb5296175bb2.svg";